import WebAuthnController from "stimulus-web-authn";
export default WebAuthnController;
